import { ApolloError, useQuery } from '@apollo/client';
import { Genre, Instrument, Sfx, Tag } from 'types/generated';
import { log } from 'utils/log';
import { EventIds } from '../../constants';
import { FiltersQuery } from './filters.gql';

export const useFiltersQuery = (): {
    data?: {
        [key: string]: Instrument[] | Genre[] | Sfx[] | Tag[];
    };
    loading: boolean;
    error?: ApolloError;
} => {
    const { loading, data, error } = useQuery(FiltersQuery, {
        notifyOnNetworkStatusChange: true,
        onError: (error: ApolloError) => {
            log.error(
                'Failed to fetch instrument, genre, descriptor or tag filters',
                EventIds.GetFiltersFailed,
                error,
            );
        },
    });

    return { data, loading, error };
};
